const moment = require('moment');
const datefns = require('date-fns');
const DateLogic = Object.create(null);

/** @typedef {import('../models/CloseDayModel.js').CloseDayItem } CloseDayItem */

DateLogic.isClosed = isClosed;
DateLogic.isClosedDateRange = isClosedDateRange;

/**
 * Permet de savoir si le jour en paramètre est fermé en prenant en compte les fermetures de toute la journée
 * @param {Array<CloseDayItem>} closeDays - Liste des journées de fermeture
 * @param {Date} date - Date à vérifier
 * @returns {boolean} - true si le jour est fermé, false sinon
 */
function isClosed(closeDays, date) {
  let isClosed = false;

  closeDays.forEach(closeDay => {
    let closeDayStartDate, closeDayEndDate;

    if (closeDay.all_day) {
      // NOTE Fermeture toute la journée : du début au fin de la journée
      closeDayStartDate = datefns.startOfDay(new Date(closeDay.start_date));
      closeDayEndDate = datefns.endOfDay(new Date(closeDay.end_date));
    } else {
      // NOTE Respecter les heures et minutes des dates
      closeDayStartDate = new Date(closeDay.start_date);
      closeDayEndDate = new Date(closeDay.end_date);
    }

    if (datefns.isWithinInterval(date, { start: closeDayStartDate, end: closeDayEndDate })) {
      isClosed = true;
    }
  });

  return isClosed;
}

/**
 * Permet de savoir si une plage de dates chevauche une journée de fermeture
 * @param {Array<CloseDayItem>} closeDays - Liste des journées de fermeture
 * @param {Date} startDate - Date de début de la plage
 * @param {Date} endDate - Date de fin de la plage
 * @returns {boolean} - true si la plage chevauche une fermeture, false sinon
 */
function isClosedDateRange(closeDays, startDate, endDate) {
  let isClosed = false;

  closeDays.forEach(closeDay => {
    let closeDayStartDate, closeDayEndDate;

    if (closeDay.all_day) {
      // NOTE Fermeture toute la journée : du début à fin de la journée
      closeDayStartDate = datefns.startOfDay(new Date(closeDay.start_date));
      closeDayEndDate = datefns.endOfDay(new Date(closeDay.end_date));
    } else {
      // NOTE Respecter les heures et minutes des dates
      closeDayStartDate = new Date(closeDay.start_date);
      closeDayEndDate = new Date(closeDay.end_date);
    }

    if (datefns.areIntervalsOverlapping(
      { start: startDate, end: endDate },
      { start: closeDayStartDate, end: closeDayEndDate }
    )) {
      isClosed = true;
    }
  });

  return isClosed;
}

module.exports = DateLogic;
